module.exports = __webpack_public_path__ + "img/1570552739.04478ae5.jpg";